export default __webpack_public_path__ + "static/media/contact_support.332da11a.svg";